import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import Step1 from './Step1/index.jsx';
import Step2 from './Step2/index.jsx';
import Step3 from './Step3/index.jsx';
import Step4 from './Step4/index.jsx';
import Step5 from './Step5/index.jsx';
import Step6 from './Step6/index.jsx';
import Step7 from './Step7/index.jsx';
import ContractorStep10 from './contractor-steps/ContractorStep10/index.jsx';
import ContractorStep11 from './contractor-steps/ContractorStep11/index.jsx';
import ContractorStep12 from './contractor-steps/ContractorStep12/index.jsx';
import ContractorStep13 from './contractor-steps/ContractorStep13/index.jsx';
import ContractorStep14 from './contractor-steps/ContractorStep14/index.jsx';
import ContractorStep15 from './contractor-steps/ContractorStep15/index.jsx';
import ContractorStep16 from './contractor-steps/ContractorStep16/index.jsx';
import ContractorStep8 from './contractor-steps/ContractorStep8/index.jsx';
import ContractorStep9 from './contractor-steps/ContractorStep9/index.jsx';
import HomeownerStep10 from './homeowner-steps/HomeownerStep10/index.jsx';
import HomeownerStep11 from './homeowner-steps/HomeownerStep11/index.jsx';
import HomeownerStep12 from './homeowner-steps/HomeownerStep12/index.jsx';
import HomeownerStep13 from './homeowner-steps/HomeownerStep13/index.jsx';
import HomeownerStep14 from './homeowner-steps/HomeownerStep14/index.jsx';
import HomeownerStep15 from './homeowner-steps/HomeownerStep15/index.jsx';
import HomeownerStep16 from './homeowner-steps/HomeownerStep16/index.jsx';
import HomeownerStep8 from './homeowner-steps/HomeownerStep8/index.jsx';
import HomeownerStep9 from './homeowner-steps/HomeownerStep9/index.jsx';
import { incrementStep } from './redux/actions.js';
import RoofSizeStep from './roof-size-step/index.jsx';

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

class WarrantyStandardForm extends React.Component {
  step(stepNum) {
    // Check if viaClaimForm is true and skip Step 1
    if (this.props.viaClaimForm === 'true' && stepNum === 1) {
      this.props.incrementStep();
      this.props.setViaClaimForm();
      this.props.setClaimData(this.props.claimData);
    }
    return {
      1: <Step1 />,
      2: <Step2 />,
      3: <Step3 />,
      4: <Step4 />,
      5: <Step5 />,
      6: <Step6 />,
      7: <Step7 />,
      8: <RoofSizeStep />,
    }[stepNum];
  }

  flowStep(stepNum, type) {
    if (stepNum > 8) {
      if (type === 'homeowner') {
        return {
          9: <HomeownerStep8 />,
          10: <HomeownerStep9 />,
          11: <HomeownerStep10 />,
          12: <HomeownerStep11 />,
          13: <HomeownerStep12 />,
          14: <HomeownerStep13 />,
          15: <HomeownerStep14 />,
          16: <HomeownerStep15 />,
          17: <HomeownerStep16 />,
        }[stepNum];
      }
      return {
        9: <ContractorStep8 />,
        10: <ContractorStep9 />,
        11: <ContractorStep10 />,
        12: <ContractorStep11 />,
        13: <ContractorStep12 />,
        14: <ContractorStep13 />,
        15: <ContractorStep15 />,
        16: <ContractorStep16 />,
      }[stepNum];
    }
  }

  render() {
    return (
      <FormWrapper {...this.props}>
        {this.step(this.props.step)}
        {this.flowStep(this.props.step, this.props.registrantType)}
      </FormWrapper>
    );
  }
}

const mapStateToProps = state => ({
  step: state.step,
  registrantType: state.formData.registrantType,
});

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  setViaClaimForm: () => dispatch({ type: 'SET_VIAFORM', viaClaimForm: true }),
  setClaimData: data => dispatch({ type: 'SET_CLAIMDATA', claimData: data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyStandardForm);
